module.exports = __webpack_public_path__ + "img/rewenshi-poster.eebcb68a.jpg";